var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCustomerService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#4F4DD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6539 72.2846C45.6539 72.2846 41.8545 72.2846 41.8545 68.4331C41.8545 64.5816 45.6539 53.0271 60.8518 53.0271C76.0496 53.0271 79.849 64.5816 79.849 68.4331C79.849 72.2846 76.0496 72.2846 76.0496 72.2846H45.6539ZM60.8518 49.1756C63.8748 49.1756 66.774 47.9583 68.9116 45.7914C71.0492 43.6245 72.2501 40.6856 72.2501 37.6211C72.2501 34.5567 71.0492 31.6178 68.9116 29.4509C66.774 27.284 63.8748 26.0667 60.8518 26.0667C57.8287 26.0667 54.9295 27.284 52.7919 29.4509C50.6543 31.6178 49.4534 34.5567 49.4534 37.6211C49.4534 40.6856 50.6543 43.6245 52.7919 45.7914C54.9295 47.9583 57.8287 49.1756 60.8518 49.1756Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8756 72.2845C38.3123 71.0821 38.0314 69.7639 38.0549 68.433C38.0549 63.2143 40.6385 57.8414 45.4106 54.1055C43.0287 53.3615 40.5471 52.9977 38.0549 53.027C22.8571 53.027 19.0576 64.5815 19.0576 68.433C19.0576 72.2845 22.8571 72.2845 22.8571 72.2845H38.8756Z",
    fill: "#CACBAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1559 49.1757C38.675 49.1757 41.0911 48.1613 42.8724 46.3555C44.6537 44.5498 45.6545 42.1007 45.6545 39.547C45.6545 36.9933 44.6537 34.5441 42.8724 32.7384C41.0911 30.9327 38.675 29.9182 36.1559 29.9182C33.6367 29.9182 31.2206 30.9327 29.4393 32.7384C27.658 34.5441 26.6572 36.9933 26.6572 39.547C26.6572 42.1007 27.658 44.5498 29.4393 46.3555C31.2206 48.1613 33.6367 49.1757 36.1559 49.1757Z",
    fill: "#CACBAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomerService);
export default __webpack_public_path__ + "static/media/icon-customer-service.e75a58e70b2b64d28e9c3258f4b03240.svg";
export { ForwardRef as ReactComponent };